import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import {
  OpensearchPaginationCursorSchema,
  PaginationCursorSchema,
} from "@redotech/redo-model/tables/table";
import { VALID_PAGE_SIZES } from "@redotech/redo-model/views/views";
import * as z from "zod";

export const getFulfillmentGroupSummaries = {
  name: "getFulfillmentGroupSummaries" as const,
  input: AdvancedFilterInputSchema.extend({
    pageNumber: z.number(),
    pageSize: z
      .number()
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    fulfillmentGroups: z.array(FulfillmentGroupDataSchema),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};
